import { getToken } from '@ssr/utils'
import { get, ApiBase } from './request'

function getProfile() {
  return get(
    `${ApiBase.infrUserService}/account/v1/getProfileByToken`,
    {},
    {
      headers: {
        'X-User-Token': getToken(),
      },
    }
  ).then((res) => {
    if (res && res.code === 0) {
      window.sessionStorage.setItem('profile', JSON.stringify(res.data.account))
    }
    return res
  })
}

function getOtherProfile(user_id) {
  return get(`${ApiBase.infrUserService}/account/v1/getProfileById`, { id: user_id })
}

function getTotalPoints() {
  return get(
    `${ApiBase.infrPointService}/point/account/getTotalPoints`,
    {},
    {
      headers: {
        'X-User-Token': getToken(),
      },
    }
  )
}

export default {
  getToken,
  getProfile,
  getOtherProfile,
  getTotalPoints,
}
